const TOKEN2 = `onClick=window.open("https://www.clicklease.com/partner/%20beaver-tools");`;

let clkPdpObserverStarted = false;
let clkPdpTimer = null;
let lastPdpAmount = null;
let clkRenderTimer = null;

setTimeout(function () {
  start();
}, 500);

function start() {
  const isPdp = window.location.pathname.includes("/products/");

  if (isPdp) {
    renderButton();
    observePdpPrice();
  }

  renderButtonList();
  scaleClkPLButtons();
}

function getAmount(text) {
  if (!text) return null;

  const match = text
    .replace(/,/g, "")
    .match(/\d+(\.\d{1,2})?/);

  if (!match) return null;

  return Number(match[0]);
}


/* ================================
   PDP
================================ */

function getPdpPlace() {
  return (
    document.querySelector(".product__block--price .f-price") ||
    document.querySelector(".product__block--price") ||
    document.querySelector(".f-price")
  );
}

function getPdpPrice() {
  return (
    document.querySelector(
      ".product__info-wrapper .f-price__sale .f-price-item--sale"
    ) ||
    document.querySelector(
      ".product__info-wrapper .f-price-item.f-price-item--sale"
    ) ||
    document.querySelector(
      ".product__info-wrapper .f-price__regular .f-price-item--regular"
    ) ||
    document.querySelector(
      ".product__info-wrapper .f-price-item.f-price-item--regular"
    )
  );
}

function renderButton() {
  const place = getPdpPlace();
  const price = getPdpPrice();

  if (!price || !place) return;

  const amount = getAmount(price.innerText);

  if (!amount) return;

  lastPdpAmount = amount;

  const existing = document.querySelector(".ClkButton");

  if (existing) {
    const currentAmount = existing.getAttribute("data-amount");

    if (String(amount) !== currentAmount) {
      updatePdpButton(amount, existing);
    }

    return;
  }

  validation(amount, place, "pdp");
}

function observePdpPrice() {
  if (clkPdpObserverStarted) return;

  const target =
    document.querySelector(".product__block--price") ||
    document.querySelector(".product__info-wrapper .f-price");

  if (!target) return;

  const observer = new MutationObserver(function () {
    clearTimeout(clkPdpTimer);

    clkPdpTimer = setTimeout(function () {
      if (!window.location.pathname.includes("/products/")) return;

      const price = getPdpPrice();

      if (!price) return;

      const amount = getAmount(price.innerText);

      if (!amount) return;

      const existing = document.querySelector(".ClkButton");

      if (!existing) {
        renderButton();
        lastPdpAmount = amount;
        return;
      }

      const currentAmount = existing.getAttribute("data-amount");

      if (
        String(amount) !== currentAmount ||
        amount !== lastPdpAmount
      ) {
        lastPdpAmount = amount;
        updatePdpButton(amount, existing);
      }
    }, 150);
  });

  observer.observe(target, {
    childList: true,
    subtree: true,
    characterData: true
  });

  clkPdpObserverStarted = true;
}


/* ================================
   GLOBO PRODUCT CARDS
================================ */

function renderButtonList() {
  const cards = document.querySelectorAll(
    "#gf-grid .product-card"
  );

  cards.forEach(function (card) {
    if (card.querySelector(".ClkButtonPL")) return;

    const place = card.querySelector(".f-price");

    if (!place) return;

    let price = null;

    const salePrice = card.querySelector(
      ".f-price__sale .f-price-item--sale"
    );

    const regularPrice = card.querySelector(
      ".f-price__regular .f-price-item--regular"
    );

    /*
     * Khi product sale:
     * ưu tiên giá sale.
     *
     * Khi không sale:
     * lấy regular price.
     */
    if (
      salePrice &&
      salePrice.offsetParent !== null
    ) {
      price = salePrice;
    } else {
      price =
        regularPrice ||
        salePrice ||
        card.querySelector(".f-price-item--sale") ||
        card.querySelector(".f-price-item--regular");
    }

    if (!price) return;

    const amount = getAmount(price.textContent);

    if (!amount) return;

    validation(
      amount,
      place,
      "pl",
      card
    );
  });
}


/* ================================
   RESPONSIVE BUTTON SCALE
================================ */

function scaleClkPLButtons() {
  document
    .querySelectorAll(".ClkButtonPL .clk-pl-outer")
    .forEach(function (outer) {
      const inner = outer.querySelector(".clk-pl-inner");

      if (!inner) return;

      const baseWidth = 190;
      const baseHeight = 58;

      const available =
        outer.clientWidth || baseWidth;

      const scale = Math.min(
        available / baseWidth,
        1
      );

      inner.style.transform =
        `scale(${scale})`;

      outer.style.height =
        `${baseHeight * scale}px`;
    });
}


/* ================================
   CLICKLEASE API
================================ */

function validation(amount, place, type, Element) {
  if (!amount || !place) return;

  if (amount < 500 || amount > 30000) return;

  const xhttp = new XMLHttpRequest();

  xhttp.onreadystatechange = function (event) {
    if (
      this.readyState !== 4 ||
      this.status !== 200
    ) {
      return;
    }

    /*
     * PDP hiện tại chỉ hiển thị từ $1500
     */
    if (
      type === "pdp" &&
      amount >= 1500
    ) {
      const existing =
        document.querySelector(".ClkButton");

      if (existing) return;

      const divContainer =
        document.createElement("div");

      divContainer.className =
        "ClkButton";

      divContainer.setAttribute(
        "data-amount",
        String(amount)
      );

      divContainer.style.width =
        "100%";

      divContainer.style.maxWidth =
        "500px";

      place.after(divContainer);

      divContainer.innerHTML =
        buttonPriceNew(event);
    }

    /*
     * Product listing Globo
     */
    if (
      type === "pl" &&
      Element
    ) {
      if (
        Element.querySelector(".ClkButtonPL")
      ) {
        return;
      }

      const divContainer =
        document.createElement("div");

      divContainer.className =
        "ClkButtonPL";

      divContainer.setAttribute(
        "data-amount",
        String(amount)
      );

      divContainer.style.width =
        "100%";

      divContainer.style.maxWidth =
        "100%";

      divContainer.style.marginLeft =
        "0";

      place.after(divContainer);

      divContainer.innerHTML =
        buttonPL(event);

      scaleClkPLButtons();
    }
  };

  xhttp.open(
    "GET",
    "https://app.clicklease.com/api/estimatedPaymentAmount/" +
    amount,
    true
  );

  xhttp.send();
}

function updatePdpButton(amount, container) {
  if (
    amount < 1500 ||
    amount > 30000
  ) {
    container.remove();
    return;
  }

  const xhttp =
    new XMLHttpRequest();

  xhttp.onreadystatechange =
    function (event) {
      if (
        this.readyState !== 4 ||
        this.status !== 200
      ) {
        return;
      }

      container.setAttribute(
        "data-amount",
        String(amount)
      );

      container.innerHTML =
        buttonPriceNew(event);
    };

  xhttp.open(
    "GET",
    "https://app.clicklease.com/api/estimatedPaymentAmount/" +
    amount,
    true
  );

  xhttp.send();
}


/* ================================
   START: MOVE LAYOUT SWITCHER NEXT TO GF-SUMMARY
   — Moves .collection__toolbar-right (View as buttons)
     into Globo's #gf-controls-container, placed before
     span.gf-summary (product count).
   — Added: 2026-09-10
================================ */

function moveLayoutSwitcher() {
  const switcher = document.querySelector(
    ".collection__toolbar-right"
  );

  const summary = document.querySelector(
    "span.gf-summary"
  );

  if (!switcher || !summary) return;

  /*
   * Only move once — if already inside
   * #gf-controls-container, skip.
   */
  if (
    switcher.closest("#gf-controls-container")
  ) return;

  const container = summary.parentElement;

  if (!container) return;

  const isMobile = window.innerWidth < 769;

  if (isMobile) {
    /*
     * Mobile: insert AFTER gf-summary (right side).
     */
    container.insertBefore(
      switcher,
      summary.nextSibling
    );
    switcher.style.marginLeft = "8px";
    switcher.style.marginRight = "0";
  } else {
    /*
     * Desktop: insert BEFORE gf-summary (left side).
     */
    container.insertBefore(
      switcher,
      summary
    );
    switcher.style.marginLeft = "0";
    switcher.style.marginRight = "8px";
  }
}

document.addEventListener(
  "DOMContentLoaded",
  moveLayoutSwitcher
);

window.addEventListener(
  "globoFilterRenderCompleted",
  function () {
    clearTimeout(clkRenderTimer);

    clkRenderTimer = setTimeout(
      function () {
        renderButtonList();
        scaleClkPLButtons();
        moveLayoutSwitcher();
      },
      150
    );
  }
);

/* ================================
   END: MOVE LAYOUT SWITCHER NEXT TO GF-SUMMARY
================================ */


window.addEventListener(
  "resize",
  function () {
    scaleClkPLButtons();
  }
);


/* ================================
   PDP BUTTON TEMPLATE
================================ */

const buttonPriceNew = (event) => {
  const response =
    JSON.parse(
      event.currentTarget.response
    );

  const monthly =
    response["object"];

  return `
    <svg
      ${TOKEN2}
      style="
        width:100%;
        margin-top:-20px;
        margin-bottom:0;
        cursor:pointer;
        max-width:500px;
      "
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 75"
      width="100%"
      height="100"
    >

      <style>

        .clk__svg text {
          text-rendering: optimizeLegibility !important;
          -webkit-font-smoothing: antialiased !important;
          text-transform: none !important;
          text-decoration: none !important;
          line-height: normal !important;
          margin: 0 !important;
          padding: 0 !important;
        }

        .clk__svg .clk__text {
          font-family:
            'Segoe UI',
            'Helvetica Neue',
            Arial,
            sans-serif !important;

          fill: #222 !important;
          font-size: 19px !important;
          font-weight: 400 !important;
          letter-spacing: .4px !important;
          word-spacing: 1px !important;
        }

        .clk__svg .clk__price {
          font-family:
            'Segoe UI',
            'Helvetica Neue',
            Arial,
            sans-serif !important;

          fill: #02ADEE !important;
          font-size: 19px !important;
          font-weight: 600 !important;
          letter-spacing: .3px !important;
        }

        .clk__svg .clk__click {
          font-family:
            'Helvetica Neue',
            Arial,
            sans-serif !important;

          fill: #02ADEE !important;
          font-size: 20px !important;
          font-weight: 700 !important;
        }

        .clk__svg .clk__lease {
          font-family:
            'Helvetica Neue',
            Arial,
            sans-serif !important;

          fill: #555 !important;
          font-size: 20px !important;
          font-weight: 700 !important;
        }

        .clk__svg .clk__btn {
          font-family:
            'Helvetica Neue',
            Arial,
            sans-serif !important;

          fill: #fff !important;
          font-size: 12px !important;
          font-weight: 700 !important;
          letter-spacing: 1.5px !important;
        }

      </style>

      <g class="clk__svg">

        <text
          x="10"
          y="55"
          class="clk__text"
        >
          As low as
        </text>

        <text
          x="105"
          y="56"
          class="clk__price"
        >
          $${monthly}
        </text>

        <text
          x="150"
          y="55"
          class="clk__text"
        >
          /mo with
        </text>

        <g
          transform="
            translate(152.5,35)
            scale(1.14)
          "
        >

          <path
            d="M316.966,16.08a5.873,5.873,0,1,1,0-7.367l6.058-2.7a12.4,12.4,0,1,0,0,12.768Z"
            transform="translate(-228)"
            fill="#20b6f1"
          ></path>

          <path
            d="M326.7,6.751l-6.126,2.733-6.129,2.731,6.129,2.733,6.126,2.734-1.622-5.463Z"
            transform="translate(-227.6 0.18)"
            fill="#636363"
          ></path>

        </g>

        <text
          x="270"
          y="55"
          class="clk__click"
        >
          click
        </text>

        <text
          x="315"
          y="55"
          class="clk__lease"
        >
          lease
        </text>

        <rect
          x="370"
          y="37"
          width="110"
          height="27"
          rx="13"
          fill="#20b6f1"
        ></rect>

        <text
          x="380"
          y="55"
          class="clk__btn"
        >
          APPLY NOW
        </text>

      </g>

    </svg>
  `;
};


/* ================================
   PRODUCT CARD BUTTON TEMPLATE
================================ */

const buttonPL = (event) => {
  const response =
    JSON.parse(
      event.currentTarget.response
    );

  const monthly =
    response["object"];

  return `
    <div ${TOKEN2} style="
      width:100%;
      max-width:100%;
      min-height:42px;
      margin-top: 5px;
      cursor:pointer;
      font-family:Arial,sans-serif;
      box-sizing:border-box;
      display:flex;
      align-items:center;
      justify-content:space-between;
      gap: 4px;
      flex-wrap: nowrap;
    ">
      <div style="
        display:flex;
        flex-direction:column;
        justify-content:center;
        min-width:0;
        line-height:1.05;
        flex-shrink:1;
      ">
        <div style="
          font-size:11px;
          color:#6b6b6b;
        ">
          Financing As Low As
        </div>

        <div style="
          display:flex;
          align-items:baseline;
          gap:2px;
          white-space:nowrap;
          margin-top:2px;
        ">
          <span style="
            font-size:12px;
            font-weight:700;
            color:#11a9e6;
            line-height:1;
          ">$</span>

          <span style="
            font-size:12px;
            font-weight:700;
            color:#11a9e6;
            line-height:1;
          ">${monthly}</span>

          <span style="
            font-size:11px;
            font-weight:700;
            color:#6b6b6b;
            line-height:1;
          ">/Month</span>
        </div>
      </div>

      <div style="
        display:flex;
        align-items:center;
        justify-content:center;
        background:#11a9e6;
        color:#fff;
        font-size:10px;
        font-weight:700;
        letter-spacing:.3px;
        text-transform:uppercase;
        padding:8px 10px;
        border-radius:999px;
        white-space:nowrap;
        line-height:1;
        flex-shrink:0;
      ">
        Apply Now!
      </div>
    </div>
  `;
};
